import useAppQuery from 'core/query-client/useAppQuery';
import { getSpecialtySpaces } from 'shared/api/specialty-spaces/http';

const useSpecialtySpacesQuery = (options = {}) =>
  useAppQuery('specialty-spaces', getSpecialtySpaces, {
    ...options,
    cacheTime: Infinity
  });

export default useSpecialtySpacesQuery;
